/* assets/waitlist-wl.js — ARS Waitlist (consolidado, sem CSS) */
(function () {

  function init(context) {
    var wrap = (context || document).getElementById("ArsWaitlist");
    if (!wrap) return;

    wrap.hidden = true;

    // dados do produto
    var productData = {};
    try { productData = JSON.parse(wrap.dataset.product || "{}"); } catch (e) {}

    // elementos
    var content   = wrap.querySelector("#ArsWaitlistContent");
    var toggle    = wrap.querySelector(".ars-waitlist__toggle");
    var closeBtn  = wrap.querySelector(".ars-waitlist__close");
    var backdrop  = wrap.querySelector("#ArsWaitlistBackdrop");

    var form      = wrap.querySelector("#WaitlistForm");
    var sizeError = wrap.querySelector("#ArsSizeError");
    var radios    = form ? form.querySelectorAll('input[name="waitlist_size"]') : [];

    var variantIdInput    = wrap.querySelector("#WaitlistVariantId");
    var variantTitleInput = wrap.querySelector("#WaitlistVariantTitle");

    var successModal = document.getElementById("ArsWaitlistSuccess");
    var successClose = successModal ? successModal.querySelector(".ars-success-modal__close") : null;

    // util
    function q(sel, ctx){ return (ctx || document).querySelector(sel); }
    function setHidden(el, val){ if (el) el.hidden = !!val; }

    // helpers de variantes
    function tamanhoIndex() {
      var opts = productData.options || [];
      for (var i = 0; i < opts.length; i++) {
        if ((opts[i] || "").toLowerCase() === "tamanho") return i + 1;
      }
      return null;
    }
    function findVariantById(id){
      return (productData.variants || []).find(function(v){ return String(v.id) === String(id); });
    }
    function selectedVariantId(){
      var el = q('form[action*="/cart/add"] [name="id"]');
      return el ? el.value : null;
    }
    function selectRadioBySize(size){
      if (!radios || !radios.length) return;
      radios.forEach(function(r){ r.checked = (r.value === size); });
    }

    // botão add-to-cart do tema (fallback)
    var atcBtn = document.querySelector('product-form button[name="add"], .product-form__submit, button[name="add"]');

    // visibilidade da waitlist
    function refreshWaitlistVisibility() {
      try {
        var id = selectedVariantId();
        var v  = id ? findVariantById(id) : null;

        var shouldShow = false;
        if (v && typeof v.available === 'boolean') {
          shouldShow = !v.available;
        } else if (atcBtn) {
          shouldShow = atcBtn.disabled || atcBtn.getAttribute('aria-disabled') === 'true';
        } else {
          shouldShow = true;
        }

        wrap.hidden = !shouldShow;
        document.body.classList.toggle('ars-waitlist-active', shouldShow);

        if (shouldShow) {
          if (v) {
            if (variantIdInput)    variantIdInput.value    = String(v.id || '');
            if (variantTitleInput) variantTitleInput.value = v.title || '';

            var idx = tamanhoIndex();
            if (idx && v['option' + idx]) selectRadioBySize(v['option' + idx]);
          }
          writeNote();
          if (radios && radios.length === 1) radios[0].checked = true;
        }
      } catch (e) {
        wrap.hidden = false;
        document.body.classList.add('ars-waitlist-active');
      }
    }

    // debounce
    var refreshTimer = null;
    function scheduleRefresh(){
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshWaitlistVisibility, 120);
    }

    // NOTE com dados úteis
    function writeNote() {
      var noteFld = document.getElementById('WaitlistNote');
      if (!noteFld) return;

      var vid = (variantIdInput && variantIdInput.value) ? String(variantIdInput.value) : '';
      var vtt = (variantTitleInput && variantTitleInput.value) ? variantTitleInput.value : '';

      var payload = {
        product_title:  (productData && productData.title)  || '',
        product_handle: (productData && productData.handle) || '',
        product_url:    location.origin + ((productData && productData.url) || location.pathname),
        variant_id:     vid,
        variant_title:  vtt
      };
      noteFld.value = JSON.stringify(payload);
    }

    // listeners de variante/DOM
    document.addEventListener("variant:change", scheduleRefresh);

    var idInput = q('form[action*="/cart/add"] [name="id"]');
    if (idInput){
      var obs = new MutationObserver(scheduleRefresh);
      obs.observe(idInput, { attributes:true, attributeFilter:["value"] });
      idInput.addEventListener("change", scheduleRefresh);
    }
    if (atcBtn) {
      var obsBtn = new MutationObserver(scheduleRefresh);
      obsBtn.observe(atcBtn, { attributes: true, attributeFilter: ["disabled", "aria-disabled"] });
      atcBtn.addEventListener("click", function(){ setTimeout(scheduleRefresh, 0); });
    }
    document.addEventListener("change", function(e){ if (e.target && e.target.name === "id") scheduleRefresh(); });

    // abrir/fechar painel
    function openPanel(){
      setHidden(content, false);
      content.classList.add("is-open");
      if (toggle) toggle.setAttribute("aria-expanded","true");


      document.documentElement.classList.add("ars-scroll-lock");
      document.body.classList.add("ars-scroll-lock");

      var firstInput = wrap.querySelector("#WaitlistName");
      setTimeout(function(){ firstInput && firstInput.focus(); }, 0);
    }
    function closePanel(){
      content.classList.remove("is-open");
      setHidden(content, true);
      if (toggle) toggle.setAttribute("aria-expanded","false");



      document.documentElement.classList.remove("ars-scroll-lock");
      document.body.classList.remove("ars-scroll-lock");
    }

    // delegação de eventos
    wrap.addEventListener("click", function(e){
      var t = e.target;
      if (t.closest && t.closest(".ars-waitlist__toggle")){
        e.preventDefault();
        return (toggle && toggle.getAttribute("aria-expanded")==="true") ? closePanel() : openPanel();
      }
      if (t.closest && t.closest(".ars-waitlist__close")){
        e.preventDefault();
        return closePanel();
      }
      var isBackdrop = backdrop && t === backdrop;
      if (isBackdrop){
        e.preventDefault();
        return closePanel();
      }
    });

    // ESC fecha
    document.addEventListener("keydown", function(e){
      if (e.key==="Escape"){ closePanel(); closeSuccess(); }
    });

    // esconder erro ao escolher tamanho
    if (radios && radios.length){
      radios.forEach(function(r){
        r.addEventListener("change", function(){ if (sizeError) sizeError.hidden = true; });
      });
    }

    // máscara WhatsApp (11 dígitos)
    var phone = wrap.querySelector("#WaitlistPhone");
    if (phone){
      phone.addEventListener("input", function(){
        var v = phone.value.replace(/\D/g,"").slice(0,11);
        var out = v;
        if (v.length>0)  out = "(" + v.slice(0,2);
        if (v.length>=2) out = "(" + v.slice(0,2) + ") " + v.slice(2);
        if (v.length>=7) out = "(" + v.slice(0,2) + ") " + v.slice(2,3) + " " + v.slice(3,7) + "-" + v.slice(7);
        phone.value = out;
      });
    }

    // ===== Modal de sucesso =====
    function openSuccess(){
      if (!successModal) return;

      // garantir botões corretos no modal
      ensureSuccessActions();

      if (backdrop){
        backdrop.hidden = false;
        backdrop.classList.add("is-open", "ars-backdrop--dim");
      }

      successModal.hidden = false;
      successModal.setAttribute("aria-hidden", "false");
      successModal.classList.add("is-open");

      document.documentElement.classList.add("ars-scroll-lock");
      document.body.classList.add("ars-scroll-lock");
    }
    function closeSuccess(){
      if (!successModal) return;

      successModal.classList.remove("is-open");
      successModal.setAttribute("aria-hidden", "true");
      successModal.hidden = true;

      if (backdrop){
        backdrop.classList.remove("is-open", "ars-backdrop--dim");
        backdrop.hidden = true;
      }

      document.documentElement.classList.remove("ars-scroll-lock");
      document.body.classList.remove("ars-scroll-lock");
    }
    if (successClose) successClose.addEventListener("click", closeSuccess);

    // cria/ajusta botões "Continuar navegando" e "Ir para a Home" no modal
    function ensureSuccessActions(){
      if (!successModal) return;
      var actions = successModal.querySelector('.ars-success-modal__actions');
      if (!actions){
        actions = document.createElement('div');
        actions.className = 'ars-success-modal__actions';
        successModal.querySelector('.ars-success-modal__box')?.appendChild(actions);
      }

      // link existente para home
      var homeLink = actions.querySelector('a.ars-btn');
      if (!homeLink){
        homeLink = document.createElement('a');
        homeLink.className = 'ars-btn ars-btn--primary';
        homeLink.href = '/';
        actions.appendChild(homeLink);
      }
      homeLink.textContent = 'Ir para a Home';

      // botão "Continuar navegando"
      var continueBtn = actions.querySelector('#ArsSuccessContinueBtn');
      if (!continueBtn){
        continueBtn = document.createElement('button');
        continueBtn.type = 'button';
        continueBtn.id = 'ArsSuccessContinueBtn';
        continueBtn.className = 'ars-btn ars-btn--primary';
        actions.insertBefore(continueBtn, homeLink); // deixa antes do link
      }
      continueBtn.textContent = 'Continuar navegando';

      // comportamento do botão continuar
      continueBtn.onclick = function(){
        closeSuccess();     // fecha modal
        closePanel();       // garante que o painel da waitlist esteja fechado
        wrap.hidden = true; // esconde o container da waitlist
        document.body.classList.remove('ars-waitlist-active');
      };
    }

    // mantém o NOTE pronto já no load
    writeNote();

    // ===== SUBMIT: BLOQUEIO HARD + validação + sucesso sem alert =====
    if (form){
      form.setAttribute('novalidate','novalidate');

      // helpers de erro por campo
      function setFieldError(inputEl, errId, show){
        if (!inputEl) return;
        inputEl.classList.toggle('is-invalid', !!show);
        inputEl.setAttribute('aria-invalid', show ? 'true' : 'false');
        var msg = errId ? document.getElementById(errId) : null;
        if (msg) msg.hidden = !show;
      }
      function has2Letters(v){ return !!(v && v.trim().replace(/\s+/g,'').length >= 2); }
      function isEmailOK(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim()); }
      function isPhoneOK(v){ var d=(v||'').replace(/\D/g,''); return d.length===11; }

      function validateSingle(inputEl){
        if (!inputEl) return true;
        var id = inputEl.id;
        if (id === 'WaitlistName')  { var ok = has2Letters(inputEl.value); setFieldError(inputEl,'ErrWaitlistName',  !ok); return ok; }
        if (id === 'WaitlistLast')  { var ok = has2Letters(inputEl.value); setFieldError(inputEl,'ErrWaitlistLast',  !ok); return ok; }
        if (id === 'WaitlistEmail') { var ok = isEmailOK(inputEl.value);  setFieldError(inputEl,'ErrWaitlistEmail', !ok); return ok; }
        if (id === 'WaitlistPhone') { var ok = isPhoneOK(inputEl.value);  setFieldError(inputEl,'ErrWaitlistPhone', !ok); return ok; }
        return true;
      }

      // revalida ao digitar e ao sair do campo (iOS friendly)
      form.addEventListener('input', function(e){ validateSingle(e.target); }, true);
      form.addEventListener('blur',  function(e){ validateSingle(e.target); }, true);

      // evita submit por Enter quando inválido
      form.addEventListener('keydown', function(e){
        if (e.key === 'Enter') {
          var first = wrap.querySelector("#WaitlistName");
          var last  = wrap.querySelector("#WaitlistLast");
          var email = wrap.querySelector("#WaitlistEmail");
          var fone  = wrap.querySelector("#WaitlistPhone");

          var ok = true;
          if (!validateSingle(first)) ok = false;
          if (!validateSingle(last))  ok = false;
          if (!validateSingle(email)) ok = false;
          if (!validateSingle(fone))  ok = false;

          if (!ok) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation && e.stopImmediatePropagation(); }
        }
      });

      form.addEventListener("submit", function(ev){
        // trava tudo — inclusive outros listeners
        ev.preventDefault();
        ev.stopPropagation && ev.stopPropagation();
        ev.stopImmediatePropagation && ev.stopImmediatePropagation();

        // remove action até validar
        var originalAction = form.getAttribute("action") || "";
        form.removeAttribute("action");

        // limpa estados antigos
        setFieldError(document.getElementById('WaitlistName'),  'ErrWaitlistName',  false);
        setFieldError(document.getElementById('WaitlistLast'),  'ErrWaitlistLast',  false);
        setFieldError(document.getElementById('WaitlistEmail'), 'ErrWaitlistEmail', false);
        setFieldError(document.getElementById('WaitlistPhone'), 'ErrWaitlistPhone', false);
        if (sizeError) sizeError.hidden = true;

        // valida tamanho (se existir)
        if (radios && radios.length){
          var chosen = Array.prototype.some.call(radios, function(r){ return r.checked; });
          if (!chosen){
            sizeError && (sizeError.hidden = false);
            sizeError && sizeError.scrollIntoView({behavior:"smooth", block:"center"});
            return; // sem action => sem envio
          }
        }

        // valida campos
        var first = wrap.querySelector("#WaitlistName");
        var last  = wrap.querySelector("#WaitlistLast");
        var email = wrap.querySelector("#WaitlistEmail");
        var fone  = wrap.querySelector("#WaitlistPhone");

        var okFirst = validateSingle(first);
        var okLast  = validateSingle(last);
        var okEmail = validateSingle(email);
        var okFone  = validateSingle(fone);

        if (!(okFirst && okLast && okEmail && okFone)){
          var firstInvalid = !okFirst ? first : (!okLast ? last : (!okEmail ? email : fone));
          if (firstInvalid){
            try { firstInvalid.scrollIntoView({behavior:'smooth', block:'center'}); } catch(_) {}
            setTimeout(function(){ try { firstInvalid.focus({preventScroll:true}); } catch(_) {} }, 180);
          }
          return; // sem action => sem envio
        }

// passou: trava botão e envia
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn){ submitBtn.disabled = true; submitBtn.classList.add("is-loading"); }

        // Prepara dados para enviar ao Google Sheets
        var firstName = (wrap.querySelector("#WaitlistName") || {}).value || '';
        var lastName = (wrap.querySelector("#WaitlistLast") || {}).value || '';
        var email = (wrap.querySelector("#WaitlistEmail") || {}).value || '';
        var phone = (wrap.querySelector("#WaitlistPhone") || {}).value || '';
        
        // Pega tamanho selecionado
        var selectedSize = '';
        if (radios && radios.length) {
          radios.forEach(function(r) {
            if (r.checked) selectedSize = r.value;
          });
        }

        // Dados do produto
        var product = (productData && productData.title) || '';
        var productUrl = location.origin + ((productData && productData.url) || location.pathname);
        var variant = selectedSize || (variantTitleInput ? variantTitleInput.value : '');

        // Monta payload JSON
        var payload = {
          firstName: firstName,
          lastName: lastName,
          email: email,
          phone: phone,
          product: product,
          variant: variant,
          productUrl: productUrl
        };

        // URL do Google Apps Script (SUBSTITUA PELA SUA URL!)
        var googleScriptUrl = 'https://script.google.com/macros/s/AKfycbzRC2XwXKtnlP62fnmGLeHMDbYED5Ac_RqtdpwWlQB3BOdktdiiw1yLvaZE1HNYWyDqCA/exec';

        fetch(googleScriptUrl, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        })
        .then(function (){
          // sucesso: fecha painel e abre modal
          form.reset();
          closePanel();
          openSuccess();
        })
        .catch(function (){
          // mesmo em erro de rede, confirma para o usuário
          closePanel();
          openSuccess();
        })
        .finally(function (){
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove("is-loading");
          }
        });
      }, true); // captura
    }

    // inicia
    refreshWaitlistVisibility();
  }

  // bootstrap
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function(){ init(document); });
  } else {
    init(document);
  }
  document.addEventListener("shopify:section:load", function(ev){
    if (ev && ev.target && ev.target.querySelector("#ArsWaitlist")) init(ev.target);
  });
  document.addEventListener("shopify:section:select", function(ev){
    if (ev && ev.target && ev.target.querySelector("#ArsWaitlist")) init(ev.target);
  });

})();
